import _ from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";

import { CommonModalHeader, useForm } from "../../../../../components";
import { ModalDialog, useMount } from "@sportal/cdk";
import {
  DeviceDialogInput,
  makeProfilePickerItems,
  ProfilesPicker,
  useDeviceNameValidator,
  DEVICE_NAME_MAX_LENGTH,
} from "../deviceForm";
import { useIntlTranslate } from "../../../../../hooks";
import { CommonModalFooter } from "../../../../../components/modal";

export function AssignDeviceDialog({ modal, profiles, devices, device }) {
  const translate = useIntlTranslate();
  const validateName = useDeviceNameValidator(devices);
  const profileSelectItems = makeProfilePickerItems(profiles, translate);
  const hasInitialValue = !!device.name;

  const form = useForm({
    name: device.name || "",
    profileName: _.find(profileSelectItems, { disabled: false }).value,
  });

  const isSubmitDisabled = () => {
    return !!validateName(form.values.name) || form.hasErrors();
  };

  useMount(() => {
    if (hasInitialValue) {
      const nameError = validateName(_.trim(device.name));

      setError("name", nameError);
    }
  });

  const changeName = (name) => {
    const nameError = validateName(_.trim(name));

    form.set("name", name);
    setError("name", nameError);
  };

  const setError = (name, error) => {
    if (!_.isEmpty(error)) {
      form.setError(`${name}`, error);
    } else {
      form.setError(`${name}`, null);
    }
  };

  const close = () => modal.reject();
  const submit = () => {
    modal.resolve({
      name: _.trim(form.values.name),
      profileName: form.values.profileName,
    });
  };

  return (
    <ModalDialog
      className="assign-device-modal"
      disabled={isSubmitDisabled()}
      submitHandler={submit}
      rejectHandler={close}
    >
      <CommonModalHeader>
        <FormattedMessage id="assign_to_profile" />
      </CommonModalHeader>
      <ModalDialog.Body>
        <DeviceDialogInput
          label="device_name"
          placeholder="enter_device_name"
          value={form.values.name}
          onChange={changeName}
          error={form.errors.name}
          autoFocus
          maxLength={DEVICE_NAME_MAX_LENGTH}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck="false"
        />
        <ProfilesPicker
          label={<FormattedMessage id="assign_to" />}
          items={profileSelectItems}
          selected={form.values.profileName}
          onChange={(value) => form.set("profileName", value)}
        />
      </ModalDialog.Body>
      <CommonModalFooter submitMessage={<FormattedMessage id="assign" />} />
    </ModalDialog>
  );
}
